<template>
  <div class="contact_section" >
    <base-row>
      <base-column>
        <base-heading :type-array="['Contact me', 'Message me']">
          <template v-slot:default >
            Get in touch
          </template>
        </base-heading>
      </base-column>
    </base-row>
    <base-row>
      <base-column :col="6" :col-sm="12">
        <contact-form></contact-form>
      </base-column>
      <base-column :col="6" :col-sm="12" class="d-flex flex-column mb-3">
        <ContactInfo>
          <template v-slot:head><h3>My Informations</h3></template>
          <template v-slot:default>
            <span>
              <base-paragraph>Phone : {{ phone }}</base-paragraph>
            </span>
            <span>
              <base-paragraph>Email : {{ email }}</base-paragraph>
            </span>
          </template>
        </ContactInfo>
      </base-column>
    </base-row>
  </div>

</template>

<script>
import ContactForm from "@/components/contact/ContactForm"
import ContactInfo from "@/components/contact/ContactInfo"
import BaseParagraph from "../components/base/BaseParagraph";

export default {
  name:"contact",
  components: {BaseParagraph, ContactInfo, ContactForm},
  computed: {
    email() {
      return this.$store.getters['contact/getEmail'];
    },
    phone() {
      return this.$store.getters['contact/getPhone'];
    },
  }
}
</script>

<style scoped>
  .contact_section {
    width: 100%;
    min-height: 100vh;
    background-color: white;
    padding-top: 3rem;
  }
</style>